var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((_vm.labels),function(label){return [_c('info-label',{attrs:{"classes":['label', `label-${_vm.labelClass(label)}`]}},[_vm._v(_vm._s(label.text))]),_vm._v(" "),void 0]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }